module.exports = __webpack_public_path__ + "3a33704907fe781fa6971c897c628c79.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/coldwell.png
// module id = 594
// module chunks = 0